import { IApplicationState, TBoardId } from '../../../../types/types';
import { getListViewBoard } from './getListViewBoard';

export const getCollapsed = (
    state: IApplicationState,
    boardId: TBoardId
): boolean => {
    return getListViewBoard(state, boardId).isCollapsed;
}
